import * as React from 'react';
import { UIComponentViewImpl } from '../../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../../../../toolkit/uicomponent';
import { CategoriesCardComponentHandler, CategoriesCardComponentProps, CategoriesCardComponentState } from './categoriescardcomponent';
import { CategoriesCardCSSStyle } from './categoriescardcssstyle';
import { BaseContext } from '../../../../../../utils/basecontext';
import { CategoriesImageLoaderCSSStyleImpl } from './categoriesimageloadercss';
import { ImageLoaderCSSStyle } from '../../../../../toolkit/imageloader/imageloadercss';
import { ImageLoaderComponent } from '../../../../../toolkit/imageloader/imageloadercomponent';

export class CategoriesCardViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private imageLoaderCSSStyle: ImageLoaderCSSStyle;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);

        this.imageLoaderCSSStyle = new CategoriesImageLoaderCSSStyleImpl(context);
    }

    bindHandlers()
    {
        this.onSelected = this.onSelected.bind(this);
        this.onHovered = this.onHovered.bind(this);
        this.onHoveredExit = this.onHoveredExit.bind(this);
    }

    draw(props: CategoriesCardComponentProps, state: CategoriesCardComponentState, cssStyle: CategoriesCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        console.log("draw on Hovered: " + state.isHovered);

        return (
            // <div className="swiper-slide">
            <div style={cssStyle.getWrapperCSSStyle()} onClick={this.onSelected} onMouseEnter={this.onHovered} onMouseLeave={this.onHoveredExit}>
               <div style={cssStyle.getTintDivCSSStyle(state.isHovered)}  onClick={this.onSelected}/>
                    {/* <img alt="" src={props.categoryDto.getImgPath()} style={cssStyle.getImgCSSStyle()}/> */}
                    <ImageLoaderComponent defaultImageName={"category_default_image.jpg"} imagePath={props.categoryDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/> 
                    <div style={cssStyle.getTitleCSSStyle()} >
                        {props.categoryDto.getTitle()}
                    </div>
            </div>
            // </div>
        );
    }

    private onHovered()
    {
     
        (this.getUIComponentHandler() as CategoriesCardComponentHandler).onHovered(true);
    }

    private onHoveredExit()
    {
        (this.getUIComponentHandler() as CategoriesCardComponentHandler).onHovered(false);
    }

    private onSelected()
    {   console.log("onHovered");
        (this.getUIComponentHandler() as CategoriesCardComponentHandler).onSelected();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/categories/viewmodel/categoriescard/categoriescardview.tsx